"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var LedgerLineTypeEnum;
(function (LedgerLineTypeEnum) {
    LedgerLineTypeEnum["Charge"] = "charge";
    LedgerLineTypeEnum["Revenue"] = "revenue";
})(LedgerLineTypeEnum = exports.LedgerLineTypeEnum || (exports.LedgerLineTypeEnum = {})); /**
* @export
* @enum {string}
*/
var LedgerLineStatusEnum;
(function (LedgerLineStatusEnum) {
    LedgerLineStatusEnum["Pending"] = "pending";
    LedgerLineStatusEnum["Final"] = "final";
})(LedgerLineStatusEnum = exports.LedgerLineStatusEnum || (exports.LedgerLineStatusEnum = {}));
function LedgerLineFromJSON(json) {
    return LedgerLineFromJSONTyped(json, false);
}
exports.LedgerLineFromJSON = LedgerLineFromJSON;
function LedgerLineFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'gross_amount': json['gross_amount'],
        'net_amount': json['net_amount'],
        'type': json['type'],
        'description': json['description'],
        'revenue_centre': json['revenue_centre'],
        'revenue_centre_name': json['revenue_centre_name'],
        'payment_processor': json['payment_processor'],
        'payment_processor_friendly': json['payment_processor_friendly'],
        'mapped_value': !runtime_1.exists(json, 'mapped_value') ? undefined : json['mapped_value'],
        'ledger_date': (new Date(json['ledger_date'])),
        'currency': json['currency'],
        'payable': _1.PayableSummary1FromJSON(json['payable']),
        'causer': _1.CauserSummary1FromJSON(json['causer']),
        'status': json['status'],
        'created_at': (new Date(json['created_at'])),
    };
}
exports.LedgerLineFromJSONTyped = LedgerLineFromJSONTyped;
function LedgerLineToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'gross_amount': value.gross_amount,
        'net_amount': value.net_amount,
        'type': value.type,
        'description': value.description,
        'revenue_centre': value.revenue_centre,
        'revenue_centre_name': value.revenue_centre_name,
        'payment_processor': value.payment_processor,
        'payment_processor_friendly': value.payment_processor_friendly,
        'mapped_value': value.mapped_value,
        'ledger_date': (value.ledger_date.toISOString()),
        'currency': value.currency,
        'payable': _1.PayableSummary1ToJSON(value.payable),
        'causer': _1.CauserSummary1ToJSON(value.causer),
        'status': value.status,
        'created_at': (value.created_at.toISOString()),
    };
}
exports.LedgerLineToJSON = LedgerLineToJSON;
